import React from 'react';

const CheckboxActive = (props) => (
  <svg 
    width="24" 
    height="24" 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M0 12C0 6.34315 0 3.51472 1.75736 1.75736C3.51472 0 6.34315 0 12 0V0C17.6569 0 20.4853 0 22.2426 1.75736C24 3.51472 24 6.34315 24 12V12C24 17.6569 24 20.4853 22.2426 22.2426C20.4853 24 17.6569 24 12 24V24C6.34315 24 3.51472 24 1.75736 22.2426C0 20.4853 0 17.6569 0 12V12Z" fill="#008000"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.717 6.97601C17.2825 7.37194 17.42 8.15137 17.0241 8.7169L11.6599 16.3788C11.6595 16.3793 11.6592 16.3799 11.6588 16.3804C11.0175 17.2998 9.75214 17.5266 8.83138 16.8859M16.717 6.97601C16.1514 6.58008 15.372 6.71757 14.9761 7.2831ZM14.9761 7.2831L9.9789 14.4208ZM9.9789 14.4208L8.99999 13.1159C8.58571 12.5637 7.8022 12.4519 7.24996 12.8661C6.69772 13.2804 6.58588 14.0639 7.00016 14.6162L8.36514 16.4357C8.49374 16.6069 8.65096 16.7603 8.83138 16.8859" fill="#fff"/>
    <path d="M8.83138 16.8859L16.717 6.97601L14.9761 7.2831L9.9789 14.4208L8.83138 16.8859Z" fill="#fff"/>
  </svg>
);

export default CheckboxActive;
